<template>
  <footer class="footer">
    <div class="footer__inner">
      <div class="footer__logo">
        <a href="/">
          <img class="is-pc" src="/assets/common/img_logo_footer.png" alt="病院事務職求人.com">
          <img class="is-sp" src="/assets/common/img_logo_sp.png" alt="病院事務職求人.com">
        </a>
      </div>
      <ul class="footerLink">
        <li class="footerLink__item"><a href="/terms" target="_blank">利用規約</a></li>
        <li class="footerLink__item"><a href="https://www.m3career.com/privacy/about/" target="_blank">個人情報の取扱いに関して</a></li>
        <li class="footerLink__item"><a href="https://www.m3career.com/contact/" target="_blank">お問い合わせ</a></li>
        <li class="footerLink__item"><a href="https://www.m3career.com/corporate-info/" target="_blank">会社概要</a></li>
      </ul>
    </div>
    <p class="footer__copyright">
      <small>&copy;2009 - 2018 M3 Career, Inc. All rights reserved.</small>
    </p>
  </footer>
</template>

<script>
  export default {

  }
</script>
